import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

const getLastSenderForPersona = (params: {
    uniqueRecipients: string[];
    isInSentOrDraftsFolder: boolean;
    lastSender: SingleRecipientType;
}): SingleRecipientType => {
    const { uniqueRecipients, isInSentOrDraftsFolder, lastSender } = params;

    if (isInSentOrDraftsFolder) {
        // Show recipient Persona for conversations belonging to drafts and sentitems folders
        if (uniqueRecipients && uniqueRecipients.length) {
            return {
                Mailbox: {
                    Name: uniqueRecipients[0],
                },
            };
        }

        // return null if there are no uniqueRecipients
        return null;
    }

    return lastSender;
};

export default getLastSenderForPersona;
